export default "__VITE_ASSET__BHXmCgvR__"